/*
 * A tiny external store so the client header (rendered above the Requests IDE,
 * outside its providers) can show the open tab's title as the trailing crumb:
 * "Client › Requests › O-1A intake". The IDE publishes the active artifact
 * while mounted; the header reads it.
 */
import { useSyncExternalStore } from "react";

let title: string | null = null;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((l) => l());

export const requestsTitleStore = {
  set(next: string | null) {
    if (next === title) return;
    title = next;
    emit();
  },
  get: () => title
};

const subscribe = (l: () => void) => {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
};

export const useRequestsTitle = (): string | null =>
  useSyncExternalStore(
    subscribe,
    () => title,
    () => title
  );
